import Vue from 'vue'
import VueRouter from 'vue-router'
import DefaultLayout from '@/views/layout/index.vue'
const Home = () => import(/* webpackChunkName: "about" */ '@/views/home/index.vue')
const About = () => import(/* webpackChunkName: "about" */ '@/views/about/index.vue')
const Quotation = () => import(/* webpackChunkName: "about" */ '@/views/product/quotation/index.vue')
const Detail = () => import(/* webpackChunkName: "about" */ '@/views/product/detail/index.vue')

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'DefaultLayout',
    component: DefaultLayout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'home',
        component: Home,
      },
      {
        path: 'about',
        name: 'about',
        component: About,
      },
    ]
  },

  {
    path: '/product',
    name: 'product',
    component: DefaultLayout,
    redirect: '/product/quotation',
    children: [
      {
        path: 'quotation',
        name: 'quotation',
        component: Quotation,
        meta: {
          part: 'product'
        }
      },
      {
        path: 'detail/:id',
        name: 'detail',
        component: Detail,
        meta: {
          part: 'product'
        }
      },
    ]
  },

]

const router = new VueRouter({
  // mode: 'history',
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

export default router
